import { IsNotEmpty, IsIn, IsBoolean } from "class-validator";

import { Constants } from "@eagerdog/constants";

import { IFarmDogScore } from "./farm-dog-score.interface";

export class FarmDogScoreDto implements IFarmDogScore {
  //
  @IsNotEmpty()
  @IsIn(Object.values(Constants.score_result_type))
  result_type: string;

  @IsNotEmpty()
  @IsBoolean()
  passed: boolean;

  greet_evaluator_initial_dog_appraisal?: boolean;

  perform_walk_pattern_around_farm_environment_and_by_passive_stranger?: boolean;

  jump_on_hay_straw_bale?: boolean;

  walk_by_farm_animal?: boolean;

  walk_over_or_through_unusual_surfaces?: boolean;

  supervised_separation?: boolean;

  pass_through_gate?: boolean;

  handler_feeds_livestock?: boolean;

  reaction_to_another_dog?: boolean;

  reaction_to_noise_distraction?: boolean;

  dog_approaches_livestock?: boolean;

  physical_examination?: boolean;

  judge_name?: string;

  judge_number?: string;

  approved_by_judge?: boolean;
}
